import { BCDataGrid } from '@bimser/components';
import DataGrid2 from '../../..';
import { ComponentProps } from 'react';

type IOnReorderArgs = ComponentProps<typeof BCDataGrid.Components.RowDragging>['onReorder'];

export const onReorder: IOnReorderArgs = function (this: DataGrid2, e) {
	let newRows = [...this.rows];
	const rowToMove = newRows.find(
		row =>
			row.cells.find(cell => cell.name === this.getUniqueDataField())?.value ===
			e.itemData[this.getUniqueDataField()]
	);

	newRows.splice(e.fromIndex, 1);
	newRows.splice(e.toIndex, 0, rowToMove);
	newRows = newRows.map((row, index) => {
		(row.data as any).index = index;
		row.index = index;
		return row;
	});

	this.set('rows', newRows);
};
